// Author liang gang qiang
// Date 2023-10-25 15:02:38

class SithMomMainProjectPlan {
constructor({
        id = null,
        prdProjectPlanId = '',
        projectCode = '',
        mainProjectTemplateId = '',
        templateName = '',
        name = '',
        mainBeginTime = '',
        mainEndTime = '',
        mainBaselineBeginTime = '',
        mainBaselineEndTime = '',
        mainBaselineBeginTimeLast = '',
        mainBaselineEndTimeLast = '',
        mainBaselineBeginDeviation = '',
        mainBaselineEndDeviation = '',
        activeStatus = '',
        releaseStatus = '',
        remark = '',
        revision = ''}
= {}) {
    this.id = id;
    this.prdProjectPlanId = prdProjectPlanId;
    this.projectCode = projectCode;
    this.mainProjectTemplateId = mainProjectTemplateId;
    this.templateName = templateName;
    this.name = name;
    this.mainBeginTime = mainBeginTime;
    this.mainEndTime = mainEndTime;
    this.mainBaselineBeginTime = mainBaselineBeginTime;
    this.mainBaselineEndTime = mainBaselineEndTime;
    this.mainBaselineBeginTimeLast = mainBaselineBeginTimeLast;
    this.mainBaselineEndTimeLast = mainBaselineEndTimeLast;
    this.mainBaselineBeginDeviation = mainBaselineBeginDeviation;
    this.mainBaselineEndDeviation = mainBaselineEndDeviation;
    this.activeStatus = activeStatus;
    this.releaseStatus = releaseStatus;
    this.remark = remark;
    this.revision = revision;
}
}

function newEntity() {
return new SithMomMainProjectPlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdProjectPlanId',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.prdProjectPlanId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.projectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'projectName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.projectName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'machine1',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.machine1',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pm',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.pm',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'pmName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.pmName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'om',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.om',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.omName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineBeginTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineBeginTimeLast',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineEndTimeLast',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineBeginDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineBeginDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'mainBaselineEndDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.mainBaselineEndDeviation',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdProjectEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.prdProjectEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omForecastStartTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.omForecastStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'omForecastEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.omForecastEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'activeStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.activeStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '启用' },
                            { value: '2', text: '冻结' }
            ]
                }
        },
        {
        key: 'releaseStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.releaseStatus',
        sortable: true,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
        ,options: [
                { value: '1', text: '未保存' },
                            { value: '2', text: '已保存，未释放' },
                            { value: '3', text: '已释放' }
            ]
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    prdProjectPlanIdFilter : '',
    projectCodeFilter : '',
    projectNameFilter : '',
    machine1Filter : '',
    pmFilter : '',
    pmNameFilter : '',
    omFilter : '',
    omNameFilter : '',
    mainProjectTemplateIdFilter : '',
    nameFilter : '',
    mainBeginTimeRteFilter : '',
    mainBeginTimeLteFilter : '',
    mainEndTimeRteFilter : '',
    mainEndTimeLteFilter : '',
    mainBaselineBeginTimeRteFilter : '',
    mainBaselineBeginTimeLteFilter : '',
    mainBaselineEndTimeRteFilter : '',
    mainBaselineEndTimeLteFilter : '',
    mainBaselineBeginTimeLastRteFilter : '',
    mainBaselineBeginTimeLastLteFilter : '',
    mainBaselineEndTimeLastRteFilter : '',
    mainBaselineEndTimeLastLteFilter : '',
    mainBaselineBeginDeviationFilter : '',
    mainBaselineEndDeviationFilter : '',
    prdProjectEndTimeRteFilter : '',
    prdProjectEndTimeLteFilter : '',
    omForecastStartTimeRteFilter : '',
    omForecastStartTimeLteFilter : '',
    omForecastEndTimeRteFilter : '',
    omForecastEndTimeLteFilter : '',
    activeStatusFilter : '',
    releaseStatusFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectCodeFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.projectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'projectNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.projectName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'machine1Filter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.machine1',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pmFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.pm',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'pmNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.pmName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.om',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omNameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.omName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineBeginTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineBeginTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLastRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineBeginTimeLastRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLastLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineBeginTimeLastLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLastRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineEndTimeLastRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLastLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineEndTimeLastLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginDeviationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineBeginDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndDeviationFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.mainBaselineEndDeviation',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdProjectEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.prdProjectEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdProjectEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.prdProjectEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omForecastStartTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.omForecastStartTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omForecastStartTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.omForecastStartTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omForecastEndTimeRteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.omForecastEndTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'omForecastEndTimeLteFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.omForecastEndTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activeStatusFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.activeStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '启用' },
                { value: '2', text: '冻结' }
            ]
        }
        },
        {
        key: 'releaseStatusFilter',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.filter.releaseStatus',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '未保存' },
                { value: '2', text: '已保存，未释放' },
                { value: '3', text: '已释放' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectCode',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdProjectPlanPrp'
            ,correspondingField: 'projectCode'
            ,fieldsBindingByEntityModalSelected: '{"prdProjectPlanId":"id"}'
                }
        },
        {
        key: 'templateName',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.templateName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMomMainProjectTemplate'
            ,correspondingField: 'taskName'
            ,fieldsBindingByEntityModalSelected: '{"mainProjectTemplateId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineBeginTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTime',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineBeginTimeLast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndTimeLast',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineEndTimeLast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineBeginDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineBeginDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'mainBaselineEndDeviation',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.mainBaselineEndDeviation',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'activeStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.activeStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'releaseStatus',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.releaseStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'revision',
        label: 'label.sith.jpa.plan.sithMomMainProjectPlan.entity.revision',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMomMainProjectPlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
